import {
  createRoutesFromElements,
  createBrowserRouter,
  Route,
  Outlet,
} from 'react-router-dom';
import { App } from './pages/app';
import { Authenticated } from './pages/authenticated';
import { Error } from './pages/error';
import { Inventories } from './pages/inventories';
import { Inventory } from './pages/inventory';
import { InventoryDefault } from './pages/inventory-default';
import { Pathways } from './pages/pathways';
import { Scenario } from './pages/scenario';
import { Baseline } from './pages/baseline';
import { Gpc } from './pages/gpc';
import { Disclosures } from './pages/disclosures';
import { Disclosure } from './pages/disclosure';
import { ScenarioSimulation } from './pages/scenario-simulation';
import { ScenarioAssumptions } from './pages/scenario-assumptions';
import { ScenarioInterventionsNew } from './pages/scenario-interventions-new';
import { ErrorNotFound } from './pages/error-not-found';
import { ErrorServer } from './pages/error-server';
import { ErrorUnknown } from './pages/error-unknown';
import { Permissions } from './pages/permissions';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      errorElement={<ErrorNotFound />}
      element={
        <QueryParamProvider adapter={ReactRouter6Adapter}>
          <Outlet />
        </QueryParamProvider>
      }
    >
      <Route path='/errors/not-found' element={<ErrorNotFound />} />
      <Route path='/errors/server' element={<ErrorServer />} />
      <Route path='/errors/unknown' element={<ErrorUnknown />} />
      <Route path='/' element={<Authenticated />} errorElement={<Error />}>
        <Route index element={<Inventories />} handle={{ type: 'emissions' }} />
        <Route
          path='communities'
          index
          element={<Inventories />}
          handle={{ type: 'emissions' }}
        />
        <Route
          path='/communities/:inventoryId'
          element={<Inventory />}
          errorElement={<Error />}
        >
          <Route element={<App />} errorElement={<Error />}>
            <Route errorElement={<Error />}>
              <Route
                index
                element={<InventoryDefault />}
                handle={{ type: 'pathways' }}
              />
              <Route
                path='pathways'
                element={<Pathways />}
                handle={{ type: 'pathways', crumb: 'pathways' }}
              />
              <Route
                path='baseline'
                element={<Baseline />}
                handle={{ type: 'baseline', crumb: 'baseline' }}
              />
              <Route
                path='gpc'
                element={<Gpc />}
                handle={{ type: 'gpc', crumb: 'gpc' }}
              />
              <Route
                path='disclosures'
                element={<Disclosures />}
                handle={{ type: 'disclosures', crumb: 'disclosures' }}
              />
              <Route
                path='disclosures/:disclosureId'
                element={<Disclosure />}
                handle={{ type: 'disclosures', crumb: 'disclosure' }}
              />
              <Route
                path='pathways/:scenarioId'
                element={<Scenario />}
                handle={{ type: 'pathways', crumb: 'scenario' }}
              >
                <Route
                  index
                  element={<ScenarioSimulation />}
                  handle={{ type: 'pathways' }}
                />
                <Route
                  path='interventions/:interventionKey'
                  element={<ScenarioAssumptions />}
                  handle={{ type: 'pathways', crumb: 'assumptions' }}
                />
                <Route
                  path='interventions/new/:category'
                  element={<ScenarioInterventionsNew />}
                  handle={{ type: 'pathways', crumb: 'assumptions' }}
                />
              </Route>
              <Route
                path='access'
                element={<Permissions />}
                handle={{ type: 'access' }}
              />
            </Route>
          </Route>
        </Route>
      </Route>
    </Route>,
  ),
);

export { router };
